import GradientButton from '@/Component/Common/Forms/GradientButton';
import ConfirmationModal from '@/Component/Common/Modal/ConfirmationModal';
import { CloseModalSVG, LoaderSVG, PayCardDeleteSVG, PayCardSVG, PayNowSVG } from '@/Component/Common/SVGs/CommonSVG';
import { getUserDetails } from '@/lib/Features/UserDetails/userDetails';
import { AppStore } from '@/lib/store';
import { BaseURL, BrandCampaignPayment, BrandPayment, DeleteCardAPI, PaymentSubScriptionsAPI } from '@/Utils/APIRequest/Endpoints';
import { CustomToast } from '@/Utils/CustomToast';
import usePost from '@/Utils/Hooks/usePost';
import { useTranslation } from '@/Utils/Hooks/useTranslate';
import { useStripe } from '@stripe/react-stripe-js';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import axios from 'axios';
import Cookies from 'js-cookie';

const ActivePlanStepOne = (props) => {
    const { setModal, modal, setCardType, CardData, refetch, selfRefetch, planRefetch, fromPayment, translations, setPremiumModal, listRefetch, planTab, fromApproval, ManagementDetailRefetch, setApproveModalOpen, setMainModal, isFromCampaignPayment, callBackFunction } = props
    const dispatch = useDispatch()
    const userDetails: any = useSelector((state: AppStore) => state.userDetailSlice?.userDetails);
    const [loader, setLoader] = useState(false);

    const [selectCard, setSelectCard] = useState("");
    const [deleteCard, setDeleteCard] = useState("");
    const stripe: any = useStripe();

    // API Subscription post
    const { isPending, mutate } = usePost(PaymentSubScriptionsAPI, null, async (response) => {
        if (response.status == 200 || response.status == 201) {
            if (response?.data) {
                const result = await stripe.confirmCardPayment(response?.data?.clientSecret);
                if (result.error) {
                    CustomToast("error", "Payment failed");
                } else {
                    setLoader(true);
                    setTimeout(() => {
                        setLoader(false);
                        let obj: any = {
                            ...userDetails, is_subscribed: true
                        }
                        dispatch(getUserDetails({ ...obj }))
                        CustomToast("success", translations?.subscribedSuccessfully)
                        setModal(null);
                        setMainModal && setMainModal(null);
                        setPremiumModal && setPremiumModal(null);
                        listRefetch && listRefetch();
                        planRefetch();
                        selfRefetch();
                    }, 8000);
                }
            } else {
                let obj: any = {
                    ...userDetails, is_subscribed: true
                }
                dispatch(getUserDetails({ ...obj }))
                CustomToast("success", translations?.subscribedSuccessfully)
                setModal(null);
                setMainModal && setMainModal(null);
                setPremiumModal && setPremiumModal(null);
                listRefetch && listRefetch();
                planRefetch();
                selfRefetch();
            }
        }
    }, null)

    // API Payment post
    const { isPending: paymentLoader, mutate: paymentMutate } = usePost(BrandPayment, null, async (response) => {
        if (response.status == 200 || response.status == 201) {
            console.log("response", response);

            if (response?.data) {
                const result = await stripe.confirmCardPayment(response?.data?.response?.paymentIntent?.clientSecret);
                if (result.error) {
                    CustomToast("error", "Payment failed");
                } else {
                    CustomToast("success", translations?.paymentSuccessful)
                    setModal(null);
                    planRefetch();
                }
            } else {
                CustomToast("success", translations?.paymentSuccessful)
                setModal(null);
                planRefetch();
            }
        }
    }, null)

    const { isPending: campaignPaymentLoader, mutate: campaignPaymentMutate } = usePost(BrandCampaignPayment, null, async (response) => {
        if (response.status == 200 || response.status == 201) {
            console.log("response", response);

            if (response?.data) {
                const result = await stripe.confirmCardPayment(response?.data?.response?.paymentIntent?.clientSecret);
                if (result.error) {
                    CustomToast("error", "Payment failed");
                    try {
                        await axios.delete(`${BaseURL}${BrandCampaignPayment}/${response?.data?.payment_id}`, {
                            headers: {
                                'Content-Type': 'application/json',
                                'Authorization': `Bearer ${Cookies.get('bat') || Cookies.get("verifyUAT")}`,
                            }
                        });
                    } catch (error) {
                        CustomToast("error", "Failed to delete card");
                    }
                } else {
                    // CustomToast("success", translations?.paymentSuccessful)
                    setModal(null);
                    callBackFunction();
                }
            } else {
                // CustomToast("success", translations?.paymentSuccessful)
                setModal(null);
                callBackFunction();
            }
        }
    }, null)

    const handleSubmit = () => {
        if (fromApproval) {
            setModal(null);
            ManagementDetailRefetch();
            setApproveModalOpen(null);
            return
        }
        if (!selectCard && modal?.id) {
            CustomToast("error", translations?.selectCard)
            return
        }
        if (fromPayment) {
            const obj: any = {
                "card_id": selectCard,
                "payment_id": modal?.id
            }
            paymentMutate(obj)
        } else if (isFromCampaignPayment) {
            console.log("selectCard", selectCard);

            const obj: any = {
                "card_id": selectCard,
                "campaign_influencer_id": modal?.id,
            }
            campaignPaymentMutate(obj)
        } else {
            const obj: any = {
                "card_id": selectCard,
                "plan_id": modal?.id,
                "interval": modal?.plan_type === "free" ? "month" : modal?.interval
            }

            console.log("obj", obj);

            // return
            mutate(obj)
        }
    }

    // API DELETE
    const { isPending: deleteLoader, mutate: deleteCardMutate } = usePost(`${DeleteCardAPI}/${deleteCard}`, null, (response) => {
        if (response.status == 200 || response.status == 201) {
            CustomToast("success", translations?.cardDeleteSuccessfully)
            refetch()
            setDeleteCard('')
            setSelectCard('')
        }
    }, 'delete')

    const callbackFunction = () => {
        deleteCardMutate()
    }


    if (paymentLoader || isPending || campaignPaymentLoader || loader) {
        return (
            <div className='fixed left-0 right-0 bottom-0 top-0 w-full h-full backdrop-blur-sm bg-black/75 z-[100] flex items-center justify-center flex-col gap-5 text-center'>
                <LoaderSVG />
                <h3 className='text-white text-lg font-medium'>
                    {translations?.paymentLoaderHeading1} <br /> {translations?.paymentLoaderHeading2}
                </h3>
            </div>
        )
    }

    return (
        <>
            {/* border-b border-lightGray */}
            <div className="  pb-5 relative">
                <div onClick={() => setModal(null)} className='absolute -top-2 -right-2 opacity-70 cursor-pointer'>
                    <CloseModalSVG customClass="max-w-6 max-h-6" />
                </div>
                <div className="flex items-center gap-5">
                    <PayNowSVG customClass="min-w-14 min-h-14" />
                    <div>
                        <h2 className="2xl:text-xl text-lg font-bold text-black leading-tight">{fromApproval ? "Input Credit Card Information" : translations?.payNow}</h2>
                        {/* <p className="text-sm font-normal text-black">Lorem ipsum dolor sit amet consectetur. Sem massa volutpat nec fermentum. Ipsum volutpat nibh tincidunt suspendisse in condimentum lacus quam. Ornare nulla aenean consectetur turpis. Mattis eu eget ultrices vitae. </p> */}
                    </div>
                </div>
            </div>
            <h2 className="text-lg font-semibold leading-6 mb-4 pt-5">{translations?.myCards}</h2>
            <div className='max-h-36 overflow-y-auto'>
                {
                    CardData?.length > 0
                        ?
                        CardData?.map((card, index) => (
                            <div key={card.card_id} className={`${selectCard == card.card_id ? "border-primary" : "border-lightGray"} flex items-center justify-between px-4 py-2.5 border-2 rounded-lg mb-3 bg-lightGray/50 cursor-pointer hover:border-primary`} onClick={() => setSelectCard(card.card_id)}>
                                <div className="flex items-center gap-4">
                                    <PayCardSVG />
                                    <div className="">
                                        <span className="text-base leading-5 block font-medium text-black">**** **** **** {card?.card_response?.card?.last4}</span>
                                        <div className="text-xs font-normal block text-gray capitalize">{card?.card_response?.card?.brand} - {translations?.expire} {card?.card_response?.card?.exp_month}/{card?.card_response?.card?.exp_year}</div>
                                    </div>
                                </div>
                                {CardData?.length > 1 && <div className="right flex items-center" onClick={() => setDeleteCard(card.id)}>
                                    <PayCardDeleteSVG />
                                </div>}
                            </div>
                        ))
                        :
                        <div className='flex flex-col items-center justify-center p-5 border border-lightGray rounded-lg text-center'>
                            <span className='text-black text-base'>{translations?.noCardFound}</span>
                            <span onClick={() => setCardType('add_card')} className='text-xs text-primary underline cursor-pointer'>{translations?.addNewCard}</span>
                        </div>
                }
            </div>
            {CardData?.length > 0 &&
                <span onClick={() => setCardType('add_card')} className="text-black underline text-xs mt-2 cursor-pointer">
                    + {translations?.addNewCard}
                </span>
            }
            <GradientButton customClass='mt-5 w-full flex items-center justify-center' disabled={isPending || CardData?.length === 0} onClick={handleSubmit} buttonType="submit">
                {fromApproval ? translations?.confirm : translations?.payNow}
                {(isPending || paymentLoader) && <LoaderSVG customClass="ml-2" />}
            </GradientButton>
            {deleteCard && <ConfirmationModal loader={deleteLoader} modal={deleteCard} args={{ message: translations?.deleteCardMessage }} setModal={setDeleteCard} callbackFunction={callbackFunction} translations={translations} />}
        </>
    );
}

export default ActivePlanStepOne;